<template>
  <div class="@container">
    <div class="w-100 d-flex gap-3 justify-content-between">
    <!-- Back -->
    <Transition name="fade">
      <button
        v-if="showBack"
        :data-cy="dataCyBack"
        class="btn btn-secondary position-relative half-size"
        :class="{
          'circle-btn-xs': shrinkOnSmBack,
        }"
        :disabled="disabledBack || !showBack"
        type="button"
        @click="emit('clickBack')"
        aria-label="back"
      >
        <TransitionGroup name="fade">
          <template v-if="shrinkOnSmBack">
            <ButtonLoadingSpinner class="display-container-xs" :displayCenter="true" v-if="!disableLoadingBack && loadingBack"></ButtonLoadingSpinner>
            <fa-icon v-else class="display-container-xs position-absolute start-0 top-0 bottom-0 start-0 end-0 ms-auto me-auto mt-auto mb-auto" :icon="['far', 'arrow-left']"></fa-icon>
          </template>

          <ButtonLoadingSpinner :class="{ 'hide-container-xs': shrinkOnSmBack }" v-if="!disableLoadingBack && loadingBack"></ButtonLoadingSpinner>
          <fa-icon v-else :class="{ 'hide-container-xs': shrinkOnSmBack }" class="position-absolute start-0 top-0 bottom-0 ps-4 mt-auto mb-auto" :icon="['far', 'arrow-left']"></fa-icon>
        </TransitionGroup>

        <span :class="{ 'hide-container-xs': shrinkOnSmBack }">
          Back
        </span>
      </button>
    </Transition>

    <!-- Next -->
    <Transition name="fade">
      <button
        v-if="showNext"
        :data-cy="dataCyNext"
        class="btn btn-primary position-relative half-size"
        :class="{
          'disabled': disabledNext,
        }"
        :disabled="disabledNext"
        type="submit"
        @click="emit('clickNext')"
        aria-label="next"
      >
        Next
        <TransitionGroup name="fade">
          <ButtonLoadingSpinner v-if="loadingNext" :displayEnd="true"></ButtonLoadingSpinner>
          <fa-icon class="position-absolute end-0 top-0 bottom-0 pe-4 mt-auto mb-auto" v-else :icon="['far', 'arrow-right']"></fa-icon>
        </TransitionGroup>
      </button>
    </Transition>

    <!-- Custom -->
    <Transition name="fade">
      <div class="half-size" v-if="$slots['custom'] && showCustom">
        <slot name="custom"></slot>
      </div>
    </Transition>
  </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['clickNext', 'clickBack'])
const disableLoadingBack = true;
const props = defineProps({
  showBack: {
    type: Boolean,
    default: true
  },
  disabledBack: {
    type: Boolean,
    default: false
  },
  loadingBack: {
    type: Boolean,
    default: false
  },
  dataCyBack: {
    type: String,
    default: 'back-app'
  },
  shrinkOnSmBack: {
    type: Boolean,
    default: true
  },

  showNext: {
    type: Boolean,
    default: true
  },
  disabledNext: {
    type: Boolean,
    default: false
  },
  loadingNext: {
    type: Boolean,
    default: false
  },
  dataCyNext: {
    type: String,
    default: 'next-app'
  },

  showCustom: {
    type: Boolean,
    default: false
  }

});

const onlyOneButton = computed(() => {
  return [props.showNext, props.showBack, props.showCustom].filter((x) => x).length <= 1
})

</script>

<style scoped lang="scss">
  .half-size {
    // For some reason because of flex and gap,
    // the width of the button on the left is slightly bigger
    // if we don't size them this way.
    flex-basis: calc(50% - 0.5rem);
    flex-grow: 1;
  }
  .circle-btn-xs {
    padding: 0;
    flex-basis: 2.75rem;
    width: 2.75rem;
    flex-grow: 0;
  }
  .display-container-xs {
    display: inline-block;
  }
  .hide-container-xs {
    display: none;
  }
  @include container-breakpoint-up(xs) {
    .display-container-xs {
      display: none;
    }
    .hide-container-xs {
      display: inline-block;
    }
    .circle-btn-xs {
      flex-basis: calc(50% - 0.5rem);
      padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
      flex-grow: 1;
    }
    .hide-text-xs {
      font-size: 1rem;
    }
  }
</style>
